<template>
    <img :src="`https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=${zoom}&size=${width}x${height}&maptype=${type}&key=${key}&markers=color:0x3183c8%7C${latitude},${longitude}&scale=2`">
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            latitude: {
                type: Number,
                required: true
            },
            longitude: {
                type: Number,
                required: true
            },
            zoom: {
                type: Number,
                required: true
            },
            width: {
                type: Number,
                required: true
            },
            height: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                default: 'roadmap'
            }
        },
        computed: {
            key () {
                return _.preload('keys.google-maps')
            }
        }
    }
</script>
